import Axios from 'axios';

class AdminRolesService {
  getAll() {
    return Axios.get('/admin/admin_roles')
      .then(({ data }) => data);
  }
}

export default new AdminRolesService();
